import {
    FETCH_USER_ADDRESS,
    FETCH_USER_ADDRESSES,
} from '../actions/userAddress';


export const initialState = {
    isFetching: true,
};

export const userAddresses = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USER_ADDRESSES}_PENDING`:
            return Object.assign({}, state, initialState);
        case `${FETCH_USER_ADDRESSES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const userAddress = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USER_ADDRESS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USER_ADDRESS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/userAddress.js